export const SEND_SHARE_DATA_REQUEST="SEND_SHARE_DATA_REQUEST"
export const SEND_SHARE_DATA_SUCCESS="SEND_SHARE_DATA_SUCCESS"
export const SEND_SHARE_DATA_FAIL="SEND_SHARE_DATA_FAIL"

export const FETCH_SHARE_DATA_REQUEST="FETCH_SHARE_DATA_REQUEST"
export const FETCH_SHARE_DATA_SUCCESS="FETCH_SHARE_DATA_SUCCESS"
export const FETCH_SHARE_DATA_FAIL="FETCH_SHARE_DATA_FAIL"